<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">
                Total Costs
            </p>
        </header>
        <div class="card-content">
            <div class="content">
                <h1>{{ total_costs | formatNumber }}</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            total_costs() {
                return this.$store.getters.getProfitSectionData.total_costs
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitTotalCosts.vue